import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=a377cd2e&scoped=true&lang=pug&"
import script from "./Scroll.vue?vue&type=script&lang=js&"
export * from "./Scroll.vue?vue&type=script&lang=js&"
import style0 from "./Scroll.vue?vue&type=style&index=0&id=a377cd2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a377cd2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a377cd2e', component.options)
    } else {
      api.reload('a377cd2e', component.options)
    }
    module.hot.accept("./Scroll.vue?vue&type=template&id=a377cd2e&scoped=true&lang=pug&", function () {
      api.rerender('a377cd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Scroll.vue"
export default component.exports